// extracted by mini-css-extract-plugin
export default {"autoplayDetail":"aSBas","counter":"kLsUH","title":"_3Eqv","contentMetadata":"J0QCe","labelRow":"HKN6Y","description":"YcR_x"};